// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./node_modules/extract-text-webpack-plugin/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-rewriter.js?id=data-v-6b0a1004&scoped=true!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/app/features/VerbalRoundtables/Dialogs/EditVerbalRoundTable.vue
// module id = 950
// module chunks = 61